import {
    formatEnumLabel,
    translateWithFallback,
} from '@/i18n/translationUtils';

const PROGRESS_LABEL_KEYS = {
    COMPLETED: 'actionItems.shared.progress.completed',
    IN_PROGRESS: 'actionItems.shared.progress.inProgress',
    NOT_STARTED: 'actionItems.shared.progress.notStarted',
};

const PRIORITY_LABEL_KEYS = {
    HIGH: 'actionItems.shared.priority.high',
    LEGISLATED: 'actionItems.shared.priority.legislated',
    LOW: 'actionItems.shared.priority.low',
    MEDIUM: 'actionItems.shared.priority.medium',
    TRIVIAL: 'actionItems.shared.priority.trivial',
};

export function getProgressIcon(progress) {
    const progressUpper = String(progress || '')
        .toUpperCase()
        .trim();
    if (progressUpper === 'COMPLETED') return 'fi-circle-check';
    return 'fi-alert-circle';
}

export function getProgressIconClass(progress) {
    const progressUpper = String(progress || '')
        .toUpperCase()
        .trim();
    if (progressUpper === 'COMPLETED') return 'progress-success';
    if (progressUpper === 'IN_PROGRESS') return 'progress-warning';
    if (progressUpper === 'NOT_STARTED') return 'progress-danger';
    return 'progress-warning';
}

export function getProgressLabel(progress, translateFn = null) {
    const progressUpper = String(progress || '')
        .toUpperCase()
        .trim();
    const labelKey = PROGRESS_LABEL_KEYS[progressUpper];
    if (labelKey) {
        return translateWithFallback(
            translateFn,
            labelKey,
            formatEnumLabel(progressUpper)
        );
    }
    return '';
}

export function getPriorityIcon(priority) {
    const priorityUpper = String(priority || '')
        .toUpperCase()
        .trim();
    if (priorityUpper === 'LOW') return 'fi-priority-low';
    if (priorityUpper === 'MEDIUM') return 'fi-priority-medium';
    if (priorityUpper === 'HIGH') return 'fi-priority-high';
    if (priorityUpper === 'LEGISLATED') return 'fi-priority-very-high';
    return 'fi-priority-trivial';
}

export function getPriorityIconClass(priority) {
    const priorityUpper = String(priority || '')
        .toUpperCase()
        .trim();
    if (priorityUpper === 'LOW') return 'priority-low';
    if (priorityUpper === 'MEDIUM') return 'priority-medium';
    if (priorityUpper === 'HIGH') return 'priority-high';
    if (priorityUpper === 'LEGISLATED') return 'priority-legislated';
    return 'priority-trivial';
}

export function getPriorityLabel(priority, translateFn = null) {
    const priorityUpper = String(priority || '')
        .toUpperCase()
        .trim();
    if (!priorityUpper) return '';
    const labelKey = PRIORITY_LABEL_KEYS[priorityUpper];
    if (labelKey) {
        return translateWithFallback(
            translateFn,
            labelKey,
            formatEnumLabel(priorityUpper)
        );
    }
    return formatEnumLabel(priorityUpper);
}

export function getAccountableNameFromStore(
    employeesStore,
    accountableId,
    translateFn = null
) {
    if (!accountableId) {
        return translateWithFallback(
            translateFn,
            'common.fallbacks.notAvailable',
            'N/A'
        );
    }
    const employee = employeesStore?.getEmployeeById(accountableId);
    if (!employee) {
        return translateWithFallback(
            translateFn,
            'common.fallbacks.unknown',
            'Unknown'
        );
    }
    return (
        `${employee.first_name || ''} ${employee.last_name || ''}`.trim() ||
        translateWithFallback(
            translateFn,
            'common.fallbacks.unknown',
            'Unknown'
        )
    );
}
